import { CasTabsView } from 'src/compass/shared/components';

import PreliminaryPayoutsLRPTab from './PreliminaryPayoutsLRPTab';
import PreliminaryPayoutsCMETab from './PreliminaryPayoutsCMETab';
import PreliminaryPayoutsOverviewTab from './PreliminaryPayoutsOverviewTab';

type PayoutsTabProps = {
  overviewRecords: any;
  cmeRecords: any;
  lrpRecords: any;
  cmeExportUrl?: string;
  lrpExportUrl?: string;
};

export default function PreliminaryPayoutsTab({
  overviewRecords,
  cmeRecords,
  lrpRecords,
  cmeExportUrl,
  lrpExportUrl,
}: PayoutsTabProps) {
  const tabList = [
    {
      label: 'Overview',
      children: <PreliminaryPayoutsOverviewTab data={overviewRecords} />,
    },
    ...(cmeRecords?.result?.length > 0
      ? [
          {
            label: 'CME',
            children: <PreliminaryPayoutsCMETab data={cmeRecords} exportUrl={cmeExportUrl} />,
          },
        ]
      : []),
    ...(lrpRecords?.result?.length > 0
      ? [
          {
            label: 'LRP',
            children: <PreliminaryPayoutsLRPTab data={lrpRecords} exportUrl={lrpExportUrl} />,
          },
        ]
      : []),
  ];

  return <CasTabsView tabList={tabList} />;
}
